module.exports = __webpack_public_path__ + "img/desktop_windows.9c30afe6.svg";